import type { RouteObject } from 'react-router';

export const routes: RouteObject[] = [
  {
    path: 'residents',
    lazy: async () => ({ Component: (await import('./ResidentsPage')).ResidentsPage }),
  },
  {
    path: 'residents/:residentId',
    lazy: async () => ({ Component: (await import('./ResidentPage')).ResidentPage }),
  },
];
